import React from "react";
import { Field, ErrorMessage } from "formik";
import { InputNumber } from "primereact/inputnumber";
import { drivingLicenseTypeOptions, commonStyles } from "./types";

interface LicenseSectionProps {
  setFieldValue: (field: string, value: any) => void;
}

export const LicenseSection: React.FC<LicenseSectionProps> = ({ setFieldValue }) => {
  const { inputClassName, labelClassName, errorClassName } = commonStyles;

  return (
    <>
      <div className="field">
        <label htmlFor="drivingLicenseNumber" className={labelClassName}>
          N° Permis
        </label>
        <Field name="drivingLicenseNumber">
          {({ field }: any) => (
            <InputNumber
              id="drivingLicenseNumber"
              value={field.value}
              onValueChange={(e) =>
                setFieldValue("drivingLicenseNumber", e.value)
              }
              className={
                inputClassName +
                "px-1 w-[calc(100%_+_0.5rem)] -translate-x-1"
              }
              useGrouping={false}
              inputClassName="w-full p-inputtext-md rounded-lg py-3"
            />
          )}
        </Field>
        <ErrorMessage
          name="drivingLicenseNumber"
          component="small"
          className={errorClassName}
        />
      </div>

      <div className="field">
        <label htmlFor="drivingLicenseType" className={labelClassName}>
          Type de Permis
        </label>
        <div className="flex justify-between space-x-4 w-2/3 mx-auto">
          {drivingLicenseTypeOptions.map((option) => (
            <label
              key={option.value}
              className="flex items-center cursor-pointer hover:-translate-y-1 transition-all ease-out duration-300"
            >
              <Field
                type="radio"
                name="drivingLicenseType"
                value={option.value}
                className="mr-2 cursor-pointer"
              />
              <span className="mr-2">
                <i className={option.icon + " text-2xl"}></i>
              </span>
              {option.label}
            </label>
          ))}
        </div>
        <ErrorMessage
          name="drivingLicenseType"
          component="small"
          className={errorClassName}
        />
      </div>
    </>
  );
};
